
import StopListApi from '@/api/stopListApi'
const api = new StopListApi()
// import Vue from 'vue'

export default {
  async getStopList(context, payload) {
    let stop_list = context.getters.getStopList,
      func = async () => {
        return await api.getStopListByCurrentOrganization()
          .then(res => {
            context.commit('setStopList', res?.organizationStopLists) 
            return res?.organizationStopLists
          })
      }
    if (!stop_list?.length || payload) {
      return await func()
    } else {
      if ( payload ) {
        func()
      }
      return stop_list
    }
  },
  
  async getOrganizationsList(context, payload) {
    let orgs_list = context.getters.getOrganizationsList
    if (!orgs_list?.length || payload) {
      return await api.getMyOrganizationList()
        .then(res => {
          context.commit('setOrganizationsList', res) 
          return res
        })
    } else {
      return orgs_list
    }
  },
   
  async getStopListByOkpo(context, payload) {
    return await api.getStopListByOkpo(payload)
  },
  
  async getOrganizationInfo(context, payload) {
    let orgs_list = context.getters.getOrganizationsList,
      item = orgs_list.find(el => el.usreou == payload || el.name == payload) 
    if ( !item && payload) {
      return await api.getOrganizationInfo(payload)
    }
    return item
  },

  async unlockInStopListByOrganizer(context, payload) {
    return await api.unlockInStopListByOrganizer(payload).then(res => {
      return res
    })
  },
  async unlockInStopList(context, payload) {
    return await api.unlockInStopList(payload).then(res => {
      return res
    })
  },
  async addToStopList(context, payload) {
    return await api.addToStopList(payload.model, payload.files)
  },

  async childListOrganizators(context, payload) {
    let child_list = context.getters.childListOrganizators
    if (!child_list?.length || payload) {
      return await api.childListOrganizators()
        .then(res => {
          context.commit('setChildListOrganizators', res) 
          return res
        })
    } else {
      return child_list
    }
  },
}